import { ORDERS_URL } from '../order.constants';

export const ORDER_STATISTICS_URL = `${ORDERS_URL}/statistics`;
